import { gsap, WF_EASE } from './gsap'

type Cleanup = (() => void) | void

const STAGGER_START = 'top bottom'

/**
 * Webflow "scroll into view" reveals (action lists a-11 / a-12 / a-13 / a-28 and
 * slideInBottom). Each element fades/moves into place the first time its top
 * crosses the bottom of the viewport. Selector-driven so the page markup stays a
 * 1:1 copy of the export.
 */
export const setupScrollReveals = (root: HTMLElement): Cleanup => {
    const reveal = (
        selector: string,
        from: gsap.TweenVars,
        vars: Partial<gsap.TweenVars> = {}
    ): void => {
        root.querySelectorAll<HTMLElement>(selector).forEach((el) => {
            gsap.fromTo(
                el,
                { autoAlpha: 0, ...from },
                {
                    autoAlpha: 1,
                    x: 0,
                    y: 0,
                    scale: 1,
                    duration: 1,
                    delay: 0.1,
                    ease: WF_EASE,
                    ...vars,
                    scrollTrigger: { trigger: el, start: STAGGER_START, toggleActions: 'play none none none' }
                }
            )
        })
    }

    // a-12 — Fade In & Move (the workhorse): opacity 0 + translateY 25 -> visible
    reveal(
        '.fade-in-move-on-scroll, .logo-small-container, .download-badge-container, .divider, .about-black-list-wrapper, .more-info-text, .open-roles-container, .open-roles-cta-holder, .blog-cta-container, .faq-block, .cards-second-grid .card-background',
        { y: 25 }
    )

    // a-11 — Fade In only
    reveal('.fade-in-on-scroll', {})

    // a-13 — Fade In & Scale (1.1 -> 1)
    reveal('.your-needs-image', { scale: 1.1 })

    // a-28 — Fade In Slow (1.5s)
    reveal('.trusted-item-header, .social-media-icon', {}, { duration: 1.5 })

    // slideInBottom — features stat blocks (offset 10%, outQuart)
    root.querySelectorAll<HTMLElement>('.company-number-facts-wrapper').forEach((el) => {
        gsap.fromTo(
            el,
            { autoAlpha: 0, y: 100 },
            {
                autoAlpha: 1,
                y: 0,
                duration: 1,
                ease: 'power4.out',
                scrollTrigger: { trigger: el, start: 'top 90%', toggleActions: 'play none none none' }
            }
        )
    })
}
